<div class="table-settings-header">
  <div class="header-title">
    <span class="br-body-2 weight--600" translate>Table Columns</span>
  </div>

  <div class="columns-container">
    <div class="column-toggle" *ngFor="let column of columnsList">
      <bringoz-switch [checked]="column.enabled"
                       [name]="column.key"
                       [label]="column.label | translate"
                       (onChange)="column.enabled = $event">
      </bringoz-switch>
    </div>
  </div>

  <div class="footer">
    <bringoz-button type="tertiary" (onClick)="onCancel()">
      <span translate>Cancel</span>
    </bringoz-button>
    <span class="flex"></span>
    <bringoz-button theme="secondary" (onClick)="onSubmit()">
      <span translate>Submit</span>
    </bringoz-button>
  </div>
</div>
